import { observer } from "mobx-react";
import { Link } from "react-router-dom";

import InfoPoint from "components/UI/InfoPoint/InfoPoint";
import { Popup } from "components/Popup/Popup";
import Button from "components/UI/Button/Button";

import popupStore from "components/Popup/PopupStore";

import { useMatchMedia } from "utils/hooks/use-match-media";

import "./Recommendation.scss";

const createSeoPoints = (hasBots) => [
  { spriteIcon: { sprite: "another", name: "recommendation-human" }, text: `Ведите трафик на сайт из ${hasBots ? "ТОП-50" : "ТОП-20"} выдачи или добавляйте к поисковым фразам название бренда` },
  { 
    spriteIcon: { sprite: "another", name: "recommendation-edit" }, 
    children:
      <ul className="recommendation__list">
        <p>Для проверки используйте <Link className="recommendation__link" to="https://metrika.yandex.ru/" target="_blank" rel="noopener noreferrer">Яндекс Метрики</Link> и <Link className="recommendation__link" to="https://metrika.yandex.ru/promo/webvisor" target="_blank" rel="noopener noreferrer">Вебвизор</Link>:</p>
        <li><span>Подключите </span> сервисы к сайту до создания проекта на бирже</li>
        <li><span>Исполнители укажут в отчете </span>время начала и конца их сессии по МСК — вы сможете проверить их по своей статистике</li>
      </ul>
  },
  { spriteIcon: { sprite: "another", name: "recommendation-setting" }, text: "Внимательно настройте проект на Boostclick. Подсказки в калькуляторе помогут подобрать оптимальный бюджет" },
];

const getInfoPointsData = (hasBots) => ({
  avito: [
    { spriteIcon: { sprite: "another", name: "recommendation-human" }, text: "Используйте ", span: "аккаунт активный более 3 месяцев" },
    { 
      spriteIcon: { sprite: "another", name: "recommendation-edit" }, 
      children: 
        <ul className="recommendation__list">
          Используйте качественное объявление:
          <li><span>Фото </span> яркие, четкие, с разных ракурсов — клиентам должно быть понятно, что вы продаете</li>
          <li><span>Описание </span>полное, отвечающее на все возможные вопросы клиентов, с ключевыми словами</li>
          <li><span>Заголовок </span>без описательных прилагательных, краткий, точный, с ключевыми словами</li>
          <li><span>Цена </span>честная, адекватная по рынку</li>
        </ul>
    },
    { spriteIcon: { sprite: "another", name: "recommendation-key" }, text: "Подберите ключевые слова для заголовка и описания на ",  link: "wordstat.yandex.ru",  to: "https://wordstat.yandex.ru/" },
    // для просмотров авито Внимательно настройте проект на Boostclick. Подсказки в калькуляторе помогут подобрать оптимальный бюджет
    { spriteIcon: { sprite: "another", name: "recommendation-setting" }, text: "Подберите оптимальный объем действий — калькулятор поможет" },
  ],
  yandexseo: createSeoPoints(hasBots),
  googleseo: createSeoPoints(hasBots),
});

const getInstructionPointsData = (marketType) => {
  const baseInstructionPoints = [
  { spriteIcon: { sprite: "another", name: "recommendation-comment" },
    children: 
      <>
        <p className="recommendation__name other-param">В поле слева добавьте задание </p>
        <div className="recommendation__task">
          <svg width="17" height="17" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x=".5" y=".449" width="16" height="16" rx="8" fill="#D2C5AC"/><path d="M8.256 13.962c-.335 0-.593-.091-.776-.274-.183-.198-.274-.465-.274-.8V9.143H3.528c-.32 0-.571-.084-.754-.251-.183-.183-.274-.434-.274-.754s.091-.563.274-.73c.183-.184.434-.275.754-.275h3.678V3.5c0-.335.091-.594.274-.777.183-.182.449-.274.8-.274.334 0 .586.092.753.274.183.183.274.442.274.777v3.632h3.678c.335 0 .586.091.754.274.182.168.274.411.274.731s-.091.571-.274.754c-.168.167-.419.251-.754.251H9.307v3.747c0 .335-.091.601-.274.799-.167.183-.426.274-.777.274z" fill="#fff"/></svg>
          <p className="recommendation__task-text">Написать отзыв о бесплатной услуге</p>
        </div>
      </>
  },
  { 
    spriteIcon: { sprite: "another", name: "recommendation-edit" }, 
    children: 
      <ul className="recommendation__list">
        <p className="recommendation__name">Составьте техническое задание для тестировщика</p>
        <li className="recommendation__description">Укажите название тестируемой услуги: выберите из популярных вариантов или введите в поле свою</li>
        <li className="recommendation__description">Расскажите, что должен проверить и отразить в публичном отзыве тестировщик</li>
        <p className="recommendation__note">Важно, чтобы эти качества можно было проверить удаленно!</p>
      </ul>
  },
  { spriteIcon: { sprite: "another", name: "recommendation-timer" },
    children: 
      <>
        <p className="recommendation__name">Дождитесь выполнения задания</p>
        <p className="recommendation__description">Тестировщик выполнит задание и оставит публичный отзыв</p>
      </>
  },
  { spriteIcon: { sprite: "another", name: "recommendation-coin" },
    children: 
      <>
        <p className="recommendation__name">Оплатите выполненную работу</p>
        <p className="recommendation__description">Проверьте отчет и оплатите работу исполнителя, если она выполнена верно. Отзыв удалили, или он так и не появился? Отклоните отчет и смените тестировщика, это бесплатно</p>
      </>
  },
];

  const onlineServicePoint = { 
    spriteIcon: { sprite: "another", name: "recommendation-list" },
    children: 
      <>
        <p className="recommendation__name">Создайте объявление с бесплатной онлайн-услугой</p>
        <p className="recommendation__description">Это может быть онлайн-консультация, предварительная оценка стоимости, удаленная диагностика, подбор услуг под запрос и пр.</p>
      </>
  };

  if (marketType === "yandexmaps") {
    return baseInstructionPoints;
  } else {
    return [onlineServicePoint, ...baseInstructionPoints];
  }
};

const Recommendation = observer(({ market, isReviewsMode, isEditGrayVisible = true, hasBots }) => {
  const { isMobile } = useMatchMedia();
  const marketType = market.id;
  const instructionPoints = getInstructionPointsData(marketType);
  const infoPointsData = getInfoPointsData(hasBots)[marketType] || [];
  const filteredInfoPoints = isEditGrayVisible ? infoPointsData : infoPointsData.filter(point => point.spriteIcon.name !== "recommendation-edit");

  // для просмотров авито Рекомендации по карточке
  const title = isReviewsMode ? "Инструкция" : "Рекомендации";
  // const subtitle = isReviewsMode ? "Как работает услуга отзыва от тестировщика?" : market.isSeo ? `Как не потратить деньги впустую и получить эффект SEO ${market.title}` : "Как не потратить деньги впустую и получить эффект от ПФ";
  
  const renderContent = () => (
    <div className="recommendation">
      <p className="recommendation__title">{title}</p>
      {/* <p className="recommendation__subtitle">{subtitle}</p> */}
      <div className="recommendation__info-points">
        {(isReviewsMode ? instructionPoints : filteredInfoPoints).map((props, index) => <InfoPoint key={index} {...props} />)}
      </div>
    </div>
  );
  
  return (
    <>    
      {isMobile ? 
        <Popup modalType="recommendation-modal">
          {renderContent()}
          <Button title="Спасибо! Учту в проекте" onClick={() => popupStore.close()} />
        </Popup>
      : renderContent()}
    </>
  );
});

export default Recommendation;
